import React, { useState, useEffect  } from "react";
import { Typography, Paper, Modal, Box, useMediaQuery, IconButton, } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

const Login = ({setDemoOpen, demoOpen, selectedSubItem}) => {
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
  console.log(selectedSubItem)
  return (
    <>
        <Modal open={demoOpen} onClose={() => setDemoOpen(false)} sx={{ backdropFilter: "blur(3px)", background: "#1D1D1D99"}} slotProps={{
            backdrop: {
            sx: {
                backgroundColor: "transparent",
                boxShadow: "none"
            },
            },
        }} disableEnforceFocus>
            <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: isSmallScreen ? "90%" : "800px", height: "auto", backgroundColor: "#FFFFFF", boxShadow: "none", overflow: "auto", borderRadius: "20px", }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" p="20px 30px">
                    <Typography sx={{ fontSize: '18px', fontWeight: 500, lineHeight: '20px', color: "#1D1D1D", paddingBottom: "2px" }}>{selectedSubItem?.tag_name} Demo Video</Typography>
                    <Box>
                        <IconButton onClick={() => setDemoOpen(false)}><CloseIcon /></IconButton>
                    </Box>
                </Box>
                <Paper elevation={3} sx={{ padding: "0", display: "flex", flexDirection: "column", alignItems: "center", background: "transparent", position: "relative", zIndex: 1, borderRadius: "20px", boxShadow: "none", width: "100%", height: "100%", }}>
                    <video src={selectedSubItem?.demo_url} autoPlay muted loop playsInline controls style={{ width: "100%", height: "100%", objectFit: "cover", }} />
                </Paper>
            </Box>
        </Modal>
    </>
  );
};

export default Login;
